import * as React from "react";
import { Textarea } from "@/components/ui/textarea";

interface ExcerptSectionProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  helperText?: string;
}

export function ExcerptSection({
  value,
  onChange,
  placeholder = "Write a brief summary...",
  helperText
}: ExcerptSectionProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200">
      <div className="p-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Excerpt
        </label>
        <Textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          rows={3}
          className="resize-none"
        />
        {helperText && (
          <p className="text-sm text-gray-500 mt-2">{helperText}</p>
        )}
      </div>
    </div>
  );
}